export class Mutex {
  mutex = Promise.resolve()

  lock() {
    let resolver = () => {}
    const result = new Promise((resolve) => {
      resolver = resolve
    })

    // whatever is running currently, let's wait untill that's done
    this.mutex = this.mutex.then(() => {
      // and then we block.
      return new Promise((resolve) => {
        // resolve is passed to `resolver` which will result in the returned promise
        // of the `lock` function to resolve with this function, and this will block
        // until caller of `lock` will execute that function which will release any
        // subsequent lock operations.
        resolver(resolve)
      })
    })

    return result
  }

  async dispatch(fn) {
    const unlock = await this.lock()
    try {
      return await Promise.resolve(fn())
    } finally {
      unlock()
    }
  }
}

/**
 * Ignores all the calls when locked
 */
export class SimpleMutex {
  token = false

  async dispatch(f) {
    if (!this.token) {
      this.token = true
      try {
        await f()
      } finally {
        this.token = false
      }
    }
  }
}
